<template>
  <div>
    <div class="container">
      <div class="custom-navbar">
        <div class="logo-wrap">
          <a :href="homeLink" class="cust-navbar-brand">
            <img src="@/assets/logo.png" alt="Topnotch" />
          </a>
        </div>
        <div class="menu-list-wrap">
          <div v-if="loggedIn" class="nav-wrap">
            <a-menu
              class="desktop-menu menu-style"
              v-model="current"
              mode="horizontal"
            >
              <a-menu-item :key="menu.key" v-for="menu in filteredMenuList">
                <router-link :to="menu.route">
                  {{ menu.name }}
                </router-link>
              </a-menu-item>
            </a-menu>
          </div>
          <div v-else class="nav-wrap">
            <a-menu
              class="desktop-menu menu-style"
              v-model="current"
              mode="horizontal"
            >
              <a-menu-item>
                <router-link to="/home">
                  HOME
                </router-link>
              </a-menu-item>
              <a-menu-item class="drop-down">
                <BaseDropdown
                  :trigger="['click']"
                  :items="recruitingMenus"
                  @on-return-value="handleHeaderMenuClick"
                >
                  <div class="header-dropdown-menu">
                    RECRUITING
                    <a-icon type="down" />
                  </div>
                </BaseDropdown>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/news">
                  NEWS
                </router-link>
              </a-menu-item>
              <a-menu-item>
                <router-link to="/login">
                  LOGIN
                </router-link>
              </a-menu-item>
            </a-menu>
          </div>
          <div class="extra-menu-wrap">
            <a-menu
              class="icon-menu-content menu-style"
              v-model="current"
              mode="horizontal"
              v-if="loggedIn"
            >
              <a-menu-item v-if="iconsVisible" class="icon-menu">
                <a-dropdown :trigger="['click']" placement="bottomRight">
                  <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                    <a-badge :count="notificationCount">
                      <a-icon type="bell" />
                    </a-badge>
                  </a>
                  <div class="notification-menu" slot="overlay">
                    <div class="head-divider">
                      Notifications
                    </div>
                    <div
                      class="noti-list"
                      v-for="(item, index) in filteredNotifications"
                      :key="index"
                    >
                      <div
                        class="noti-content"
                        :class="[{ unread: !item.isRead }]"
                      >
                        <router-link to="#">
                          <div class="noti-details">
                            <div class="noti-title">
                              {{ item.subject }}
                            </div>
                            <div class="time">
                              {{ item.createdAt | convertToFromNowFormat }}
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                    <div class="noti-footer">
                      <router-link
                        :to="`/${profileId}/notifications/${userId}`"
                      >
                        View all Notifications
                      </router-link>
                    </div>
                  </div>
                </a-dropdown>
              </a-menu-item>
              <a-menu-item v-if="iconsVisible" key="chat" class="icon-menu">
                <router-link :to="`/${profileId}/chat`">
                  <a-badge :count="unreadChatCount">
                    <a-icon type="message" />
                  </a-badge>
                </router-link>
              </a-menu-item>
              <a-menu-item class="drop-down">
                <BaseDropdown
                  :trigger="['click']"
                  :items="menuItems"
                  placement="bottomRight"
                  @on-return-value="handleClick"
                >
                  <div class="user-info">
                    <BaseImageWrapper
                      v-if="profileImagePresent"
                      :image-url="generateImageUrl(profileImage)"
                      :size="40"
                      force-image-show
                      wrapper-style="circle"
                      class="base-image-wrapper"
                    />
                    <BaseImageWrapper
                      v-else
                      :image-url="dummyImage"
                      :size="40"
                      force-image-show
                      wrapper-style="circle"
                    />
                    <div v-if="showUserName" class="profile-name">
                      <span class="full-name"> {{ getUserName }}</span>
                      <span class="first-name">
                        {{ getUserName && getUserName.split(" ")[0] }}</span
                      >
                    </div>
                    <div v-else class="profile-name">
                      <span class="full-name">{{ userName }}</span>
                      <span class="first-name">
                        {{ userName && userName.split(" ")[0] }}</span
                      >
                    </div>
                    <a-icon type="down" />
                  </div>
                </BaseDropdown>
              </a-menu-item>
            </a-menu>
            <div class="mobile-menu">
              <a-icon type="menu" class="menu-trigger" @click="showDrawer" />
              <a-drawer
                class="menu-modal custom-modal"
                placement="right"
                :visible="visible"
                @close="onClose"
              >
                <div class="logo-wrap">
                  <div class="close-drawer" @click="onClose">
                    <div class="line1"></div>
                    <div class="line2"></div>
                  </div>
                </div>
                <a-menu
                  v-if="loggedIn"
                  v-model="current"
                  mode="inline"
                  class="menu-style"
                >
                  <a-menu-item :key="menu.key" v-for="menu in filteredMenuList">
                    <router-link :to="menu.route">
                      {{ menu.name }}
                    </router-link>
                  </a-menu-item>
                </a-menu>
                <a-menu
                  v-else
                  class="desktop-menu menu-style text-align-center"
                  v-model="current"
                >
                  <a-menu-item>
                    <router-link to="/home">
                      HOME
                    </router-link>
                  </a-menu-item>
                  <a-menu-item class="drop-down">
                    <BaseDropdown
                      :trigger="['click']"
                      extraclass="menu-dropdown"
                      :items="recruitingMenus"
                      @on-return-value="handleHeaderMenuClick"
                    >
                      <div class="header-dropdown-menu">
                        RECRUITING
                        <a-icon type="down" />
                      </div>
                    </BaseDropdown>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link to="/news">
                      NEWS
                    </router-link>
                  </a-menu-item>
                  <a-menu-item>
                    <router-link to="/login">
                      LOGIN
                    </router-link>
                  </a-menu-item>
                </a-menu>
              </a-drawer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--topbar -->
    <div class="second-menu-wrap">
      <div class="container">
        <a-menu
          :class="Boolean(loggedIn) ? 'second-menu' : 'reverse-second-menu'"
          v-model="current"
          mode="horizontal"
        >
          <a-menu-item
            :class="[selectedMenu(menu.key) ? 'ant-menu-item-selected' : '']"
            :key="menu.key"
            v-for="menu in filteredSecondMenuList"
          >
            <router-link :to="`${menu.route}?key=${menu.key}`">
              {{ menu.name }}
            </router-link>
          </a-menu-item>
        </a-menu>
        <!-- <a-menu
          :class="Boolean(loggedIn) ? 'second-menu' : 'reverse-second-menu'"
          v-model="current"
          mode="horizontal"
        >
          <a-menu-item key="profile-list" v-if="onlyPlayer()">
            <router-link to="/profile">
              Profiles list
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="profile-list-player"
            v-if="onlyPlayer() && $route.params.profileId"
          >
            <router-link :to="profileSummary">
              Edit Profile
            </router-link>
          </a-menu-item>
          <a-menu-item key="college-profile" v-if="onlyCollegeCoach()">
            <router-link :to="`/${profileId}/college_profile/summary`">
              College Profile
            </router-link>
          </a-menu-item>
          <a-menu-item key="club-profile" v-if="onlyClubCoach()">
            <router-link :to="`/${profileId}/club_profile/summary`">
              Club Profile
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="college-search"
            v-if="
              exceptBasicPlayer() &&
                exceptClubHeadCoach() &&
                profileIdPresent &&
                !hideMenuItems &&
                $route.params.profileId
            "
          >
            <router-link :to="`/${profileId}/colleges`">
              Search Colleges
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="club-search"
            v-if="
              exceptBasicPlayer() &&
                profileIdPresent &&
                !hideMenuItems &&
                $route.params.profileId
            "
          >
            <router-link :to="`/${profileId}/clubs`">
              Search Clubs
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="athlete-search"
            v-if="
              onlyCollegeCoach() ||
                (onlyClubCoach() && profileIdPresent && $route.params.profileId)
            "
          >
            <router-link :to="`/${profileId}/athletes`">
              Search Players
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="college-events"
            v-if="
              exceptClubHeadCoach() &&
                exceptBasicPlayer() &&
                profileIdPresent &&
                !hideMenuItems &&
                $route.params.profileId
            "
          >
            <router-link :to="`/${profileId}/college_events`">
              College Events
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="club-events"
            v-if="
              exceptBasicPlayer() &&
                profileIdPresent &&
                !hideMenuItems &&
                $route.params.profileId
            "
          >
            <router-link :to="`/${profileId}/club_events`">
              Club Events
            </router-link>
          </a-menu-item>
          <a-menu-item
            key="favourites"
            v-if="!hideMenuItems && $route.params.profileId"
          >
            <router-link :to="`/${profileId}/favourites/college`">
              Favourites
            </router-link>
          </a-menu-item>
          <a-menu-item v-if="Boolean(!loggedIn)">
            <router-link to="/contact">
              Contact
            </router-link>
          </a-menu-item>
          <a-menu-item v-if="Boolean(!loggedIn)">
            <router-link to="/about">
              About Tna
            </router-link>
          </a-menu-item>
          <a-menu-item v-if="Boolean(!loggedIn)">
            <router-link to="/pricing">
              Pricing
            </router-link>
          </a-menu-item>
        </a-menu> -->
      </div>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("users");

const SUBHEADERS = {
  favourites: [
    { label: "COLLEGES", value: "/favourites/college" },
    { label: "COLLEGE EVENTS", value: "/favourites/college_event" },
    { label: "CLUBS", value: "/favourites/club_team" },
    { label: "CLUB EVENTS", value: "/favourites/club_event" },
    {
      label: "Player",
      value: "/favourites/athlete",
      permissions: [
        "collegeHeadCoach",
        "clubHeadCoach",
        "premiumclubHeadCoach",
        "collegeNormalCoach",
        "collegeProfileMaintainer"
      ]
    }
  ],
  college_profile: [
    { label: "Profile Summary", value: "/profile_summary" },
    {
      label: "BASIC INFORMATION",
      value: "/info",
      permissions: ["collegeHeadCoach", "collegeProfileMaintainer"]
    },
    {
      label: "PICTURES",
      value: "/pictures",
      permissions: ["collegeHeadCoach", "collegeProfileMaintainer"]
    },
    {
      label: "VIDEO",
      value: "/video",
      permissions: ["collegeHeadCoach", "collegeProfileMaintainer"]
    },
    {
      label: "COACHING STAFF",
      value: "/college_profile/coaching_staffs",
      permissions: ["collegeHeadCoach", "collegeProfileMaintainer"]
    },
    {
      label: "EVENTS",
      value: "/events",
      permissions: ["collegeHeadCoach", "collegeProfileMaintainer"]
    },
    {
      label: "HIGHLIGHTS",
      value: "/college_profile/team_highlights",
      permissions: ["collegeHeadCoach", "collegeProfileMaintainer"]
    }
  ],
  club_profile: [
    { label: "Profile Summary", value: "/profile_summary" },
    {
      label: "BASIC INFORMATION",
      value: "/info"
    },
    {
      label: "PICTURES",
      value: "/pictures"
    },
    {
      label: "VIDEO",
      value: "/video"
    },
    {
      label: "COACHING STAFF",
      value: "/club/coaching_staffs"
    },
    {
      label: "EVENTS",
      value: "/events"
    },
    {
      label: "HIGHLIGHTS",
      value: "/club/team_highlights"
    },
    { label: "Roster", value: "/roster" }
  ]
};

import commonMixin from "../../mixins/commonMixin.js";
import DummyImage from "@/assets/images/dummy-profile-picture.png";
import { mapGetters, mapActions } from "vuex";
import { Base } from "@/models";
import { Notification } from "ant-design-vue";

const PLAYER_STORE_KEY = "playerStore";
const ATHLETE_STORE_KEY = "athleteStore";
const CHAT_STORE_KEY = "chatStore";
const COACH_STORE_KEY = "coachStore";
const NOTIFICATION_STORE = "notificationStore";

export default {
  mixins: [commonMixin],
  data() {
    return {
      dummyImage: DummyImage,
      current: ["user"],
      visible: false,
      headerRouteMapper: {
        "player recruiting": "/player-recruiting",
        "college recruiting": "/college-recruiting",
        "club recruiting": "/club-recruiting"
      },
      menuList: [
        {
          key: "home",
          name: "home",
          route: this.$route.params.profileId
            ? `/${this.$route.params.profileId}/home`
            : "/home",
          visible: true
        },
        {
          key: "recruiting",
          name: "Recruiting",
          route: this.$route.params.profileId
            ? `/${this.$route.params.profileId}/player-recruiting`
            : "/player-recruiting",
          visible: this.onlyPlayer()
        },
        {
          key: "recruiting",
          name: "Recruiting",
          route: this.$route.params.profileId
            ? `/${this.$route.params.profileId}/club-recruiting`
            : "/club-recruiting",
          visible: this.onlyClubCoach()
        },
        {
          key: "recruiting",
          name: "Recruiting",
          route: this.$route.params.profileId
            ? `/${this.$route.params.profileId}/college-recruiting`
            : "/college-recruiting",
          visible: this.onlyCollegeCoach()
        },
        {
          key: "pricing",
          name: "Pricing",
          route: this.$route.params.profileId
            ? `/${this.$route.params.profileId}/pricing-detail`
            : `/pricing-detail`,
          visible: this.exceptCollegeCoach()
        },
        {
          key: "news",
          name: "news",
          route: this.$route.params.profileId
            ? `/${this.$route.params.profileId}/news`
            : "/news",
          visible: true
        },
        {
          key: "myprofiles",
          name: "My profiles",
          route: `/${this.$route.params.profileId}/myprofiles`,
          visible: this.loggedIn
        },
        {
          key: "myaccount",
          name: "My account",
          route: `/${this.$route.params.profileId}/transaction-history`,
          visible: this.loggedIn
        }
      ],
      collegeSeconMenuList: [
        {
          key: "profile-list-player",
          name: "Edit Profile",
          route: `/${this.$route.params.profileId}/athelete/summary`,
          visible: this.onlyPlayer() && this.$route.params.profileId
        },
        {
          key: "profile-list",
          name: "Profiles list",
          route: "/profile",
          visible: this.onlyPlayer()
        },
        {
          key: "college-profile",
          name: "College Profile",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/college_profile/summary`,
          visible: this.onlyCollegeCoach()
        },
        {
          key: "club-profile",
          name: "Club Profile",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/club_profile/summary`,
          visible: this.onlyClubCoach()
        },
        {
          key: "athlete-search",
          name: "Search Players",
          route: `/${Base.profileId() ||
            this.$route.params.profileId ||
            localStorage["profileId"]}/athletes`,
          visible:
            (this.onlyCollegeCoach() && this.$route.params.profileId) ||
            (this.onlyClubCoach() &&
              Boolean(
                this.$route.params.profileId || localStorage["profile-id"]
              ) &&
              this.$route.params.profileId)
        },
        {
          key: "club-search",
          name: "Search Clubs",
          route: `/${Base.profileId() ||
            this.$route.params.profileId ||
            localStorage["profileId"]}/clubs`,
          visible:
            this.exceptBasicPlayer() &&
            Boolean(
              this.$route.params.profileId || localStorage["profile-id"]
            ) &&
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        // {
        //   key: "club-events",
        //   name: "Club Events",
        //   route: `/${Base.profileId() ||
        //     this.$route.params.profileId ||
        //     localStorage["profileId"]}/club_events`,
        //   visible:
        //     this.exceptBasicPlayer() &&
        //     Boolean(
        //       this.$route.params.profileId || localStorage["profile-id"]
        //     ) &&
        //     !(this.$route.name.toLowerCase() === "profilelist") &&
        //     this.$route.params.profileId
        // },
        {
          key: "college-search",
          name: "Search Colleges",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/colleges`,
          visible:
            this.exceptBasicPlayer() &&
            this.exceptClubHeadCoach() &&
            Boolean(
              this.$route.params.profileId || localStorage["profile-id"]
            ) &&
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        // {
        //   key: "college-events",
        //   name: "College Events",
        //   route: `/${Base.profileId() ||
        //     this.$route.params.profileId ||
        //     localStorage["profileId"]}/college_events`,
        //   visible:
        //     this.exceptClubHeadCoach() &&
        //     this.exceptBasicPlayer() &&
        //     Boolean(
        //       this.$route.params.profileId || localStorage["profile-id"]
        //     ) &&
        //     !(this.$route.name.toLowerCase() === "profilelist") &&
        //     this.$route.params.profileId
        // },
        {
          key: "favourites",
          name: "Favorites",
          route: this.exceptPlayer()
            ? `/${Base.profileId() ||
                this.$route.params.profileId ||
                localStorage["profileId"]}/favourites/athlete`
            : `/${Base.profileId() ||
                this.$route.params.profileId ||
                localStorage["profileId"]}/favourites/college`,
          visible:
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        {
          key: "contact",
          name: "Contact",
          route: `/contact`,
          visible: Boolean(!localStorage["user-permissions"])
        },
        {
          key: "pricing",
          name: "Pricing",
          route: `/pricing`,
          visible: Boolean(!localStorage["user-permissions"])
        },
        {
          key: "about",
          name: "About Tna",
          route: `/about`,
          visible: Boolean(!localStorage["user-permissions"])
        }
      ],
      clubSecondMenuList: [
        {
          key: "college-profile",
          name: "College Profile",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/college_profile/summary`,
          visible: this.onlyCollegeCoach()
        },
        {
          key: "club-profile",
          name: "Club Profile",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/club_profile/summary`,
          visible: this.onlyClubCoach()
        },
        {
          key: "athlete-search",
          name: "Search Players",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/athletes`,
          visible:
            this.onlyCollegeCoach() ||
            (this.onlyClubCoach() &&
              Boolean(
                this.$route.params.profileId || localStorage["profile-id"]
              ) &&
              this.$route.params.profileId)
        },
        {
          key: "college-search",
          name: "Search Colleges",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/colleges`,
          visible:
            this.exceptBasicPlayer() &&
            this.exceptClubHeadCoach() &&
            Boolean(
              this.$route.params.profileId || localStorage["profile-id"]
            ) &&
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        // {
        //   key: "college-events",
        //   name: "College Events",
        //   route: `/${Base.profileId() ||
        //     this.$route.params.profileId ||
        //     localStorage["profileId"]}/college_events`,
        //   visible:
        //     this.exceptClubHeadCoach() &&
        //     this.exceptBasicPlayer() &&
        //     Boolean(
        //       this.$route.params.profileId || localStorage["profile-id"]
        //     ) &&
        //     !(this.$route.name.toLowerCase() === "profilelist") &&
        //     this.$route.params.profileId
        // },
        {
          key: "club-search",
          name: "Search Clubs",
          route: `/${Base.profileId() ||
            this.$route.params.profileId ||
            localStorage["profileId"]}/clubs`,
          visible:
            this.exceptBasicPlayer() &&
            Boolean(
              this.$route.params.profileId || localStorage["profile-id"]
            ) &&
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        // {
        //   key: "club-events",
        //   name: "Club Events",
        //   route: `/${Base.profileId() ||
        //     this.$route.params.profileId ||
        //     localStorage["profileId"]}/club_events`,
        //   visible:
        //     this.exceptBasicPlayer() &&
        //     Boolean(
        //       this.$route.params.profileId || localStorage["profile-id"]
        //     ) &&
        //     !(this.$route.name.toLowerCase() === "profilelist") &&
        //     this.$route.params.profileId
        // },
        {
          key: "favourites",
          name: "Favorites",
          route: this.exceptPlayer()
            ? `/${Base.profileId() ||
                this.$route.params.profileId ||
                localStorage["profileId"]}/favourites/athlete`
            : `/${Base.profileId() ||
                this.$route.params.profileId ||
                localStorage["profileId"]}/favourites/college`,
          visible:
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        {
          key: "contact",
          name: "Contact",
          route: `/contact`,
          visible: Boolean(!localStorage["user-permissions"])
        },
        {
          key: "pricing",
          name: "Pricing",
          route: `/pricing`,
          visible: Boolean(!localStorage["user-permissions"])
        },
        {
          key: "about",
          name: "About Tna",
          route: `/about`,
          visible: Boolean(!localStorage["user-permissions"])
        }
      ],
      recruitingMenus: [
        "Player Recruiting",
        "Club Recruiting",
        "College Recruiting"
      ]
    };
  },
  async mounted() {
    this.chatSockets.clearEvents();
    this.chatSockets.addEvents([
      { name: "userForceLogout", handler: this.logOut },
    ]);
    if (this.$route.params.profileId && this.getUserPermission === "player") {
      await this.$store.dispatch(`athleteStore/getAthlete`, {
        id: this.$route.params.profileId
      });
      this.setProfileData(this.athlete);
      localStorage["user-name"] = JSON.stringify(this.athlete.athletename);
      localStorage["user-image"] =
        this.athlete.profileImage || this.athlete.image;
    }
    if (this.$route.params.profileId && this.onlyClubCoach()) {
      await this.$store.dispatch(`${COACH_STORE_KEY}/getSingleCoach`, {
        id: this.$route.params.profileId
      });
      localStorage["user-name"] = JSON.stringify(this.singleCoach.coachname);
      localStorage["user-image"] =
        this.singleCoach.image || this.singleCoach.profileImage;
    }
    if (this.$route.params.profileId && this.onlyCollegeCoach()) {
      await this.$store.dispatch(`${COACH_STORE_KEY}/getSingleCollegeCoach`, {
        id: JSON.parse(localStorage["user-id"])
      });
      localStorage["user-name"] = JSON.stringify(this.singleCoach.coachname);
      localStorage["user-image"] =
        this.singleCoach.image || this.singleCoach.profileImage;
    }
    if (Base.isLoggedIn()) {
      await this.$store.dispatch(`${NOTIFICATION_STORE}/getAllNotifications`, {
        grpType: Base.userType() === "athlete" ? "player" : Base.userType(),
        userId:
          this.athlete.userId ||
          (localStorage["user-id"] && JSON.parse(localStorage["user-id"]))
      });
      if (this.onlyPlayer || this.onlyClubCoach) {
        this.$route.params.profileId &&
          (await this.$store.dispatch(
            `${NOTIFICATION_STORE}/renewalSystemNotification`,
            {
              profileId: this.$route.params.profileId,
              page: 1
            }
          ));
      }
    }
  },
  computed: {
    filteredNotifications() {
      const newNotificationArray = new Array(
        ...this.notifications,
        ...this.upgradeNotifications
      );
      newNotificationArray.sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt)
      );
      return newNotificationArray.splice(0, 5);
    },
    notificationCount() {
      return (
        Number(this.upgradeNotiMeta.unReadNotifications || 0) +
        Number(this.systemNotiMeta.unReadNotifications || 0)
      );
    },
    playerSecondMenuList() {
      return [
        {
          key: "profile-list",
          name: "Profiles list",
          route: "/profile",
          visible: this.onlyPlayer()
        },
        {
          key: "profile-list-player",
          name: "Edit Profile",
          route: `/${this.$route.params.profileId}/athelete/summary`,
          visible: this.onlyPlayer() && this.$route.params.profileId
        },
        {
          key: "college-profile",
          name: "College Profile",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/college_profile/summary`,
          visible: this.onlyCollegeCoach()
        },
        {
          key: "club-profile",
          name: "Club Profile",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/club_profile/summary`,
          visible: this.onlyClubCoach()
        },
        {
          key: "college-search",
          name: "Search Colleges",
          route: `/${this.$route.params.profileId ||
            localStorage["profile-id"]}/colleges`,
          visible:
            this.exceptBasicPlayer() &&
            this.exceptClubHeadCoach() &&
            Boolean(
              this.$route.params.profileId || localStorage["profile-id"]
            ) &&
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        // {
        //   key: "college-events",
        //   name: "College Events",
        //   route: `/${Base.profileId() ||
        //     this.$route.params.profileId ||
        //     localStorage["profileId"]}/college_events`,
        //   visible:
        //     this.exceptClubHeadCoach() &&
        //     this.profileType != "Basic" &&
        //     Boolean(
        //       this.$route.params.profileId || localStorage["profile-id"]
        //     ) &&
        //     !(this.$route.name.toLowerCase() === "profilelist") &&
        //     Boolean(this.$route.params.profileId)
        // },
        {
          key: "club-search",
          name: "Search Clubs",
          route: `/${Base.profileId() ||
            this.$route.params.profileId ||
            localStorage["profileId"]}/clubs`,
          visible:
            this.exceptBasicPlayer() &&
            Boolean(
              this.$route.params.profileId || localStorage["profile-id"]
            ) &&
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId
        },
        {
          key: "athlete-search",
          name: "Search Players",
          route: `/${Base.profileId() ||
            this.$route.params.profileId ||
            localStorage["profileId"]}/athletes`,
          visible:
            this.onlyCollegeCoach() ||
            (this.onlyClubCoach() &&
              Boolean(
                this.$route.params.profileId || localStorage["profile-id"]
              ) &&
              this.$route.params.profileId)
        },
        // {
        //   key: "club-events",
        //   name: "Club Events",
        //   route: `/${Base.profileId() ||
        //     this.$route.params.profileId ||
        //     localStorage["profileId"]}/club_events`,
        //   visible:
        //     this.exceptBasicPlayer() &&
        //     Boolean(
        //       this.$route.params.profileId || localStorage["profile-id"]
        //     ) &&
        //     !(this.$route.name.toLowerCase() === "profilelist") &&
        //     this.$route.params.profileId
        // },
        {
          key: "favourites",
          name: "Favorites",
          route: this.exceptPlayer()
            ? `/${Base.profileId() ||
                this.$route.params.profileId ||
                localStorage["profileId"]}/favourites/athlete`
            : `/${Base.profileId() ||
                this.$route.params.profileId ||
                localStorage["profileId"]}/favourites/college`,
          visible:
            !(this.$route.name.toLowerCase() === "profilelist") &&
            this.$route.params.profileId &&
            this.exceptBasicPlayer()
        },
        {
          key: "contact",
          name: "Contact",
          route: `/contact`,
          visible: Boolean(!localStorage["user-permissions"])
        },
        {
          key: "pricing",
          name: "Pricing",
          route: `/pricing`,
          visible: Boolean(!localStorage["user-permissions"])
        },
        {
          key: "about",
          name: "About Tna",
          route: `/about`,
          visible: Boolean(!localStorage["user-permissions"])
        }
      ];
    },
    isVisible() {
      return (
        this.exceptClubHeadCoach() &&
        this.profileType != "Basic" &&
        Boolean(this.$route.params.profileId || localStorage["profile-id"]) &&
        !(this.$route.name.toLowerCase() === "profilelist") &&
        Boolean(this.$route.params.profileId)
      );
    },
    getUserName() {
      if (this.onlyPlayer()) return this.athlete.athletename;
      return this.singleCoach.coachname;
    },
    profileImagePresent() {
      return Boolean(this.profileImage && this.showUserName);
    },
    userId() {
      return this.athlete.userId || JSON.parse(localStorage["user-id"]);
    },
    userName() {
      if (this.onlyPlayer()) return JSON.parse(localStorage["user-name"]);
      return this.singleCoach.coachname;
    },
    secondMenuList() {
      if (this.onlyPlayer()) return this.playerSecondMenuList;
      if (this.onlyCollegeCoach()) return this.collegeSeconMenuList;
      else return this.clubSecondMenuList;
    },
    profileImage() {
      if (this.onlyPlayer()) {
        return this.athlete.profileImage;
      }
      if (this.onlyCollegeCoach()) {
        return this.singleCoach.profileImage;
      } else {
        return this.singleCoach.image;
      }
    },
    homeLink() {
      return localStorage["profile-id"]
        ? `/${localStorage["profile-id"]}/home`
        : `${window.location.origin}/home`;
    },
    profileId() {
      return (
        this.$route.params.profileId ||
        Base.profileId() ||
        localStorage["profileId"]
      );
    },
    iconsVisible() {
      return Boolean(this.$route.params.profileId);
    },
    filteredMenuList() {
      return this.menuList.filter(item => item.visible);
    },
    filteredSecondMenuList() {
      let w = window.innerWidth;
      let that = this;
      if (w <= 575) {
        let k = that.$route.query.key;
        that.secondMenuList.forEach(function(item, i) {
          if (item.key === k) {
            that.secondMenuList.splice(i, 1);
            that.secondMenuList.unshift(item);
          }
        });
      }
      return this.secondMenuList.filter(item => item.visible);
    },
    loggedIn() {
      return localStorage["user-permissions"];
    },
    profileSummary() {
      return `/${this.$route.params.profileId}/athelete/summary`;
    },
    hideMenuItems() {
      return this.$route.name.toLowerCase() === "profilelist";
    },
    menuItems() {
      if (Base.userType() === "athlete") return ["Change Password", "Logout"];
      else if (Base.userType() === "clubCoach")
        return (this.$route.path === '/404' || this.$route.path === '/403') ? ["Change Password", "Logout"] : ["Edit Profile", "My Account", "Change Password", "Logout"];
      else return (this.$route.path === '/404' || this.$route.path === '/403') ? ["Change Password", "Logout"] : ["Edit Profile", "Change Password", "Logout"];
    },
    profileIdPresent() {
      return Boolean(
        this.$route.params.profileId ||
          localStorage["profile-id"] ||
          this.$route.params.id
      );
    },
    showUserName() {
      return !(
        this.$route.name === "ProfileList" ||
        this.$route.name === "ChangePassword"
      );
    },
    routeItems() {
      const intersection = _.intersection(
        this.$route.path.split("/"),
        Object.keys(SUBHEADERS)
      );
      let subheaders = SUBHEADERS[intersection[0]] || [];
      subheaders = subheaders.filter(subheader => {
        if (!subheader.permissions) return true;
        return (
          subheader.permissions &&
          subheader.permissions.includes(
            JSON.parse(localStorage["user-permissions"])
          )
        );
      });
      return subheaders;
    },
    routeName() {
      const routes = this.$route.path.split("/");
      return routes[routes.length - 1];
    },
    profileType() {
      return (
        this.athleteProfileData.profileType || localStorage["profile-type"]
      );
    },
    getUserPermission() {
      return (
        localStorage["user-permissions"] &&
        JSON.parse(localStorage["user-permissions"])
      );
    },
    ...mapGetters({
      athleteProfileData: `${PLAYER_STORE_KEY}/getViewProfileData`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
      unreadChatCount: `${CHAT_STORE_KEY}/unreadChatCount`,
      coach: `${COACH_STORE_KEY}/coach`,
      notifications: `${NOTIFICATION_STORE}/notifications`,
      upgradeNotifications: `${NOTIFICATION_STORE}/upgradeNotifications`,
      systemNotiMeta: `${NOTIFICATION_STORE}/systemNotiMeta`,
      upgradeNotiMeta: `${NOTIFICATION_STORE}/upgradeNotiMeta`,
      singleCoach: `${COACH_STORE_KEY}/singleCoach`
    })
  },
  methods: {
    ...mapActions({
      setProfileData: `${PLAYER_STORE_KEY}/setViewProfileData`
    }),
    logOut(msg){
      let logged_by = msg.logoutType;
      let logged_msg = msg.message;
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem('logged_by', logged_by)
      localStorage.setItem('logged_msg', logged_msg);
      this.chatSockets.tearDownConnection();
      window.location.href = "/login";
    },
    selectedMenu(key) {
      return key === this.$route.query.key;
    },
    goToRoute(route) {
      this.$router.push(route);
    },
    handleHeaderMenuClick(value) {
      let route = this.headerRouteMapper[value.toLowerCase()];
      this.$router.push({ path: route });
    },
    async handleClick(event) {
      if (event.toLowerCase() === "change password") {
        this.$router.push("/change-password")
      }
      if (event.toLowerCase() === "logout") {

        const profileId = localStorage.getItem('profile-id');
        UserRepository.logoutUser({profileId})
        .then(res=> {
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/login";
        })
        .catch((err)=>{
          localStorage.clear();
          sessionStorage.clear();
          window.location.href = "/login";
        })
        return;
      }
      if (event.toLowerCase() === "edit profile") {
        if (Base.userType() === "clubCoach") {
          this.$router.push(
            `/${this.profileId}/club/coaching_staffs/${Base.profileId()}/edit`
          );
        } else {
          this.$router.push(
            `/${
              this.profileId
            }/college_profile/coaching_staffs/${Base.userId()}/edit`
          );
        }
      }
      if (event.toLowerCase() === "my account") {
        this.$router.push({
          path: `/${Base.profileId()}/transaction-history`,
          query: { name: this.getUserName }
        });
      }
    },
    getFirstWord(str) {
      if (!str) return "";

      let spaceIndex = str.indexOf(" ");
      return spaceIndex === -1 ? str : str.substr(0, spaceIndex);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    handleOk(e) {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
// custom notification
.custom-navbar {
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .cust-navbar-brand {
    img {
      width: 160px;
    }
  }
  .menu-list-wrap {
    display: flex;
    align-items: center;
  }
  .ant-menu-submenu-title {
    text-transform: uppercase;
    padding: 0 10px;
  }
}

.ant-menu-horizontal,
.ant-menu-inline {
  &.menu-style {
    background: none;
    border-bottom: none;
    margin-top: 0;
    line-height: initial;
    > {
      .ant-menu-item,
      .ant-menu-submenu {
        padding: 0 15px;
        border-bottom: none !important;
        a {
          font-size: 16px;
          font-weight: 400;
          color: #4f5152;
          margin-top: 0;
          text-transform: uppercase;
          @include customTransition(0.2s, linear);
          &:hover {
            color: #d73228;
          }
          &.nuxt-link-exact-active {
            color: #d73228;
          }
        }
        .ant-btn-primary {
          text-transform: uppercase;
          border-radius: 20px !important;
          font-size: 12px;
          padding: 0 20px;
          height: 32px !important;
          @include customTransition(0.2s, linear);
          &:hover {
            background: #fff;
            color: $brand-color;
            border: 1px solid $brand-color;
            @include boxShadow(0px, 3px, 8px, 2px, rgba(0, 0, 0, 0.3));
          }
        }
      }
    }
    .user-info {
      display: flex;
      align-items: center;
      cursor: pointer;
      .img-wrap {
        width: 30px;
        height: 30px !important;
        border-radius: 50%;
        background: grey;
      }
      .profile-name {
        font-family: $content-font;
        font-size: 13px;
        font-weight: 600;
        color: $secondary-color;
        margin: 0 5px 0 10px;
        text-transform: capitalize;
        .first-name {
          display: none;
        }
      }
      .anticon {
        padding-top: 1px;
        color: $secondary-color;
        font-size: 16px;
        font-weight: bold;
      }
    }
    .menu-list-wrap {
      display: flex;
      align-items: center;
    }
  }
  &.icon-menu-content {
    display: flex;
    align-items: center;
    .icon-menu {
      .anticon {
        font-size: 20px;
        margin: 0;
      }
      .ant-badge-count {
        p {
          margin: 0 !important;
        }
      }
    }
    .drop-down {
      padding-right: 0;
      .anticon {
        margin: 0;
      }
    }
  }
}

.mobile-menu {
  .menu-trigger {
    display: none;
  }
}

.custom-modal {
  .ant-modal-footer {
    display: none;
  }
  .ant-modal-content {
    border-radius: 0;
    position: relative;
    margin: 30px 0;
  }
  .ant-modal-body {
    padding: 0;
  }
  .cross {
    position: absolute;
    z-index: 1;
    cursor: pointer;
    width: 40px;
    height: 40px;
    right: -18px;
    top: -18px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    .img-wrap {
      width: 15px;
    }
  }
}

.menu-modal {
  .ant-drawer-content-wrapper {
    min-width: 300px;
  }
  .ant-drawer-body {
    padding: 0;
    padding-top: 60px;
    .menu-style {
      .ant-menu-item {
        &::after {
          right: initial;
          left: 0;
        }
      }
      .ant-menu-submenu-title {
        padding-left: 10px !important;
      }
    }
  }
}

// Second menu css
.second-menu-wrap {
  background: #d73228;
  .second-menu {
    background: #d73228;
    border-bottom: none;
    .ant-menu-item {
      margin: 0;
      padding: 0;
      border-bottom: 6px solid #d73228 !important;
      a {
        color: #fff;
        padding: 4px 15px;
        font-size: 16px;
        text-transform: uppercase;
        font-weight: 700;
        position: relative;
        &:hover {
          color: #fff;
        }
      }
      &:hover {
        border-color: #fff !important;
      }
      &.ant-menu-item-selected {
        border-color: #fff !important;
      }
    }
    .ant-menu-overflowed-submenu {
      top: 0;
      border: none !important;
      .ant-menu-submenu-title {
        > span {
          color: white;
          font-size: 36px;
        }
      }
    }
  }
  .reverse-second-menu {
    background: #d73228 !important;
    border-bottom: none;
    display: flex;
    flex-direction: row-reverse;
    .ant-menu-item {
      margin: 0;
      padding: 0;
      border-bottom: 6px solid #d73228 !important;
      a {
        color: #fff !important;
        padding: 4px 15px;
        font-size: 16px;
        text-transform: uppercase;
        font-weight: 700;
        position: relative;
        &:hover {
          color: #fff !important;
        }
      }
      &:hover {
        border-color: #fff !important;
      }
      &.ant-menu-item-selected {
        border-color: #fff !important;
      }
    }
    .ant-menu-overflowed-submenu {
      top: 0;
      border: none !important;
      .ant-menu-submenu-title {
        > span {
          color: white;
          font-size: 36px;
        }
      }
    }
  }
}

.ant-menu-submenu {
  &.ant-menu-submenu-popup {
    .ant-menu-submenu-content {
      background: #d73228;
      .ant-menu-item {
        padding: 0;
        margin: 0;
        height: 100%;
        line-height: initial;
        > a {
          color: #fff;
          padding: 20px 20px 0;
          font-size: 14px;
          text-transform: uppercase;
          font-weight: 700;
          position: relative;
        }
        &:last-child {
          > a {
            padding-bottom: 20px;
          }
        }
      }
    }
  }
}

// End custom navbar

.player-strip .login li {
  color: #fff !important;
  padding: 0 10px;
  font-size: 14px;
  margin-left: 10px;
  display: inline-block;
  overflow: hidden;
  text-transform: uppercase;
  font-weight: 700;
}
.latest-events .event-footer a,
.highlight-footer a {
  font-size: 16px;
  font-weight: 700;
  color: black;
}
a {
  color: black;
}
.account-dropdown {
  padding-top: 10px;
  padding-left: 20px;
  .ant-btn-link {
    color: black;
  }
}
.notification-menu {
  background: #ffffff;
  border-radius: 6px;
  min-width: 300px;
  box-shadow: 0 8px 20px 3px rgba(0, 0, 0, 0.13);
  .head-divider {
    font-family: $content-font;
    font-size: 14px;
    color: #d73228;
    font-weight: 600;
    padding: 15px 20px;
  }
  .noti-list {
    .noti-content {
      padding: 10px 20px;
      background: #fbfbfb;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: calc(100% - 40px);
        height: 1px;
        background: rgba(0, 0, 0, 0.1);
        left: 50%;
        bottom: 0;
        transform: translate3d(-50%, 0, 0);
      }
      .noti-details {
        font-family: $content-font;
        cursor: auto !important;
        .noti-title {
          font-size: 12px;
          color: #535353;
        }
        .time {
          font-size: 10px;
          font-weight: 600;
          color: #196fc7;
        }
      }
      &.unread {
        background: #efefef;
        .noti-title {
          color: #000;
          font-weight: 600;
        }
      }
      &:last-child {
        &::before {
          width: 100%;
        }
      }
    }
  }
  .noti-footer {
    a {
      display: block;
      width: 100%;
      padding: 15px 20px;
      font-family: $content-font;
      font-size: 12px;
      color: #2a338e;
      font-weight: 600;
      text-align: center;
      &:hover {
        color: #d73228;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .custom-navbar {
    .cust-navbar-brand {
      img {
        width: 135px;
      }
    }
    .desktop-menu {
      display: none;
    }
    .extra-menu-wrap {
      display: flex;
      align-items: center;
    }
  }
  .mobile-menu {
    margin-left: 20px;
    .menu-trigger {
      display: block;
      font-size: 20px;
    }
  }
}

@media only screen and (max-width: 575px) {
  .menu-modal {
    .ant-drawer-content-wrapper {
      width: 100% !important;
    }
  }
}
@media only screen and (max-width: 425px) {
  .custom-navbar {
    .cust-navbar-brand {
      img {
        width: 110px;
      }
    }
  }
  .ant-menu-horizontal,
  .ant-menu-vertical {
    &.menu-style {
      > .ant-menu-item {
        padding: 0;
        width: 100%;
      }
      .anticon-message {
        padding: 8px;
      }
      .user-info {
        .image-circle-width-40 {
          display: none;
        }
        .img-wrap {
          display: none;
        }
        .profile-name {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 75px;
          margin-left: 0;
          .full-name {
            display: none;
          }
          .first-name {
            display: inline;
          }
        }
      }
    }
  }
  .mobile-menu {
    margin-left: 10px;
    .menu-trigger {
      display: block;
      font-size: 20px;
    }
  }
  .menu-modal {
    .ant-drawer-close {
      right: 20px;
      top: 10px;
      font-size: 24px;
    }
    .ant-drawer-body {
      padding-top: 75px;
      .ant-menu-horizontal,
      .ant-menu-vertical,
      .ant-menu-inline {
        &.menu-style {
          > {
            .ant-menu-item,
            .ant-menu-submenu {
              a {
                font-weight: 600;
                font-size: 16px;
                text-align: center;
              }
              .header-dropdown-menu {
                font-weight: 600;
                font-size: 16px;
                color: rgba(0, 0, 0, 0.65);
              }
            }
          }
        }
      }
    }
  }
  .ant-dropdown-menu {
    &.menu-dropdown {
      width: 90%;
      margin: 0 auto;
      padding: 20px 0 !important;
      .ant-dropdown-menu-item {
        padding: 10px 10px;
        font-weight: 500;
        font-size: 16px;
        text-align: center;
      }
    }
  }
}
@media only screen and (max-width: 375px) {
  .anticon-message {
    padding: 6px;
  }
  .user-info {
    .image-circle-width-40 {
      display: none;
    }
  }
}
</style>
